<template>
  <div class="container">
    <Progress
      :active-index="0"
      :step-list="stepList"
    />
    <div class="main">
      <div class="insureInfoReplenish">
        “投标人信息完善”业务组件占位
      </div>
      <PickCompany
        class="pickCompany"
        @change="handlePickCompany"
      />
      <Operate class="operate" />
    </div>
    <DocumentDialog
      class="insureInfo"
      title="投保须知"
      content="123<br />456"
      ok-text="我已阅读投保须知并同意"
      cancel-text="不同意，取消投保"
      :is-show-know-tips="false"
      :visible="insureInfoDialog.visible"
      @ok="()=>{insureInfoDialog.visible=false}"
      @cancel="()=>{insureInfoDialog.visible=false;closePage()}"
    />
  </div>
</template>

<script>

import DocumentDialog from '@/components/DocumentDialog';
import Progress from './../../components/Progress';
import Operate from './components/Operate';
import PickCompany from './components/PickCompany';
export default {
  name: 'InsurePage',
  components: {
    Progress,
    Operate,
    PickCompany,
    DocumentDialog,
  },
  data() {
    return {
      stepList: [ '填写投保信息', '确认投保信息', '提交投保完成' ],
      pickCompanyCode: '',
      insureInfoDialog: {
        visible: true,
      },
    };
  },
  methods: {
    handlePickCompany(code) {
      this.pickCompanyCode = code;
    },
    closePage() {
      if (navigator.userAgent.indexOf('Firefox') !== -1 || navigator.userAgent.indexOf('Chrome') !== -1) {
        window.location.href = 'about:blank';
        window.close();
      } else {
        window.opener = null;
        window.open('', '_self');
        window.close();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.container{
  background-color: #fff;
  min-height: 600px;
}
.main{
  padding: 30px 50px 95px;
}
.pickCompany{
  margin-top:90px;
}
.operate{
  margin-top:80px;
}
</style>
